import React, { useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const BASEURL = process.env.REACT_APP_BASE_URL;
const DownloadReport = () => {
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());
    const [loading, setLoading] = useState<boolean>(false);

    const formatDate = (date: Date): string => {
        return date.toISOString().split("T")[0];
    };

    const fetchData = async () => {
        if (!startDate || !endDate) return;
        if (startDate > endDate) {
            alert("Start date cannot be after end date.");
            return;
        }

        try {
            setLoading(true);
            const userToken = localStorage.getItem("auth-token");
            if (!userToken) throw new Error("No authentication token found");

            const formattedStart = formatDate(startDate);
            const formattedEnd = formatDate(endDate);
            const token = userToken.replace(/^"|"$/g, '')
            const response = await axios.get(
                `${BASEURL}/v1/fisherman/downloadreport?startDate=${formattedStart}&endDate=${formattedEnd}`,
                {
                    headers: {
                        "x-user-token": userToken,
                        
                       Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    },
                    responseType: "blob", // ✅ Receive binary file
                }
            );

             console.log(" IN MATCH SATGE OF DOWNLOAD SECTION REPORT ====== 1.0 FE");
            // ✅ Create download link
            const blob = new Blob([response.data], {
                type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `report_${formattedStart}_to_${formattedEnd}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // ✅ Release blob memory

        } catch (err: any) {
            console.error("Download error:", err);
            if (axios.isAxiosError(err) && err.response?.status === 401) {
                window.location.href = "/login";
            } else {
                alert("Failed to download report. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };
//     const fetchData = async () => {
//     if (!startDate || !endDate) return;
//     if (startDate > endDate) {
//         alert("Start date cannot be after end date.");
//         return;
//     }

//     try {
//         setLoading(true);
//         const userToken = localStorage.getItem("auth-token");
//         if (!userToken) throw new Error("No authentication token found");

//         const formattedStart = formatDate(startDate);
//         const formattedEnd = formatDate(endDate);

//         const response = await axios.get(
//             `/api/v1/fisherman/downloadreport?startDate=${formattedStart}&endDate=${formattedEnd}`,
//             {
//                 headers: {
//                     "x-user-token": userToken,
//                     Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                 },
//                 responseType: "blob" // ✅ Receive binary file
//             }
//         );

//         const blob = new Blob([response.data], {
//             type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         });

//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = `report_${formattedStart}_to_${formattedEnd}.xlsx`;
//         document.body.appendChild(link);
//         link.click();
//         link.remove();
//         window.URL.revokeObjectURL(url);

//     } catch (err: any) {
//         console.error("Download error:", err);
//         if (axios.isAxiosError(err) && err.response?.status === 401) {
//             window.location.href = "/login";
//         } else {
//             alert("Failed to download report. Please try again.");
//         }
//     } finally {
//         setLoading(false);
//     }
// };

    return (
        <div
            className="p-6 max-w-7xl mx-auto bg-gray-50 min-h-screen rounded-lg shadow"
            style={{ marginTop: "44px", borderRadius: "70px" }}
        >
            {/* Header & Date Picker */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-3">
                <h1 className="text-3xl font-extrabold text-gray-900">
                    Download Report
                </h1>
                <div className="flex gap-3 items-center flex-wrap">
                    <label className="text-gray-700 font-semibold text-sm">From:</label>
                    <DatePicker
                        selected={startDate}
                        onChange={(date: Date | null) => setStartDate(date)}
                        maxDate={new Date()}
                        dateFormat="yyyy-MM-dd"
                        className="border border-gray-300 px-3 py-1 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        placeholderText="Start Date"
                    />
                    <label className="text-gray-700 font-semibold text-sm ml-2">
                        To:
                    </label>
                    <DatePicker
                        selected={endDate}
                        onChange={(date: Date | null) => setEndDate(date)}
                        minDate={startDate ?? undefined}
                        maxDate={new Date()}
                        dateFormat="yyyy-MM-dd"
                        className="border border-gray-300 px-3 py-1 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        placeholderText="End Date"
                    />
                </div>
            </div>

            {/* Download Button */}
            <div className="flex justify-end">
                <button
                    disabled={loading || !startDate || !endDate}
                    onClick={fetchData}
                    className={`px-6 py-2 rounded-md text-white font-semibold transition duration-200 ${
                        loading || !startDate || !endDate
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                    }`}
                >
                    {loading ? "Downloading..." : "Download Report"}
                </button>
            </div>
        </div>
    );
};

export default DownloadReport;
